var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 6.125H11.375V4.375C11.375 1.96 9.415 0 7 0C4.585 0 2.625 1.96 2.625 4.375V6.125H1.75C0.7875 6.125 0 6.9125 0 7.875V16.625C0 17.5875 0.7875 18.375 1.75 18.375H12.25C13.2125 18.375 14 17.5875 14 16.625V7.875C14 6.9125 13.2125 6.125 12.25 6.125ZM4.375 4.375C4.375 2.9225 5.5475 1.75 7 1.75C8.4525 1.75 9.625 2.9225 9.625 4.375V6.125H4.375V4.375ZM12.25 16.625H1.75V7.875H12.25V16.625ZM7 14C7.9625 14 8.75 13.2125 8.75 12.25C8.75 11.2875 7.9625 10.5 7 10.5C6.0375 10.5 5.25 11.2875 5.25 12.25C5.25 13.2125 6.0375 14 7 14Z",
    fill: "#0064E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.1c091d4ea3130c9b38a5103022282b26.svg";
export { ForwardRef as ReactComponent };